// extracted by mini-css-extract-plugin
export default {"wrapper":"pagination_wrapper__ayHXk","nextAndPrev":"pagination_nextAndPrev__unpIW","loadmoreButton":"pagination_loadmoreButton__Cb9AS","leftAuto":"pagination_leftAuto__hmDPn"};